import { logger } from "@/shared/lib/logger";
import { apiClient } from '@/shared/api/client';
import { Scenario } from '../types/alpha.types';

export const getScenarios = async (): Promise<Scenario[]> => {
  try {
    const response = await apiClient.get('/mocks/alpha/scenarios.json');
    return response.data;
  } catch (error) {
    logger.error('Failed to fetch scenarios:', error);
    throw new Error('Failed to load scenarios');
  }
};